import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

import { IConfigBix, IMessageRequestBix, IMessageAnswerOpenAI } from "@core/models";

@Injectable({ providedIn: "root" })
export class BixService {
  
  private currentConfigSubject: BehaviorSubject<IConfigBix>;

  /**
   * Constructor
   * @param {HttpClient} _http
  */
  constructor(private _http: HttpClient) {
    this.currentConfigSubject = new BehaviorSubject(null);
  }

  // getter: currentUserValue
  public get currentConfigValue(): IConfigBix {
    return this.currentConfigSubject.value;
  }

  // getter: event current user value changed
  public get onCurrentConfigChanged(): Observable<IConfigBix> {
    return this.currentConfigSubject.asObservable();
  }

  /**
   * Registra la configuración inicial de bix
   * @param {IConfigBix} configuration Registra la configuración
   */
  register(config: IConfigBix): void{
    this.currentConfigSubject.next(config);
  }

  /**
   * Función para enviar consultas al modelo AI
   * @param {IMessageRequestBix} message Indica el cuerpo del mensaje para hacer una petición a open ai
   * @returns {IMessageAnswerOpenAI} Devuelve un mensaje con la respuesta del modelo AI
   */
  sendMessage(message: IMessageRequestBix): Promise<IMessageAnswerOpenAI>{
    
    const endpoint = `${this.currentConfigValue.configData.url}?code=${this.currentConfigValue.configData.siteKey}`;

    return this._http.post<IMessageAnswerOpenAI>(endpoint,message).toPromise();
  }

}
